// @flow
import geocode from 'geocode'
import type { Address } from 'types'

export const US_STATES = {
  AL: 'Alabama',
  AK: 'Alaska',
  AZ: 'Arizona',
  AR: 'Arkansas',
  CA: 'California',
  CO: 'Colorado',
  CT: 'Connecticut',
  DE: 'Delaware',
  DC: 'District of Columbia',
  FL: 'Florida',
  GA: 'Georgia',
  HI: 'Hawaii',
  ID: 'Idaho',
  IL: 'Illinois',
  IN: 'Indiana',
  IA: 'Iowa',
  KS: 'Kansas',
  KY: 'Kentucky',
  LA: 'Louisiana',
  ME: 'Maine',
  MD: 'Maryland',
  MA: 'Massachusetts',
  MI: 'Michigan',
  MN: 'Minnesota',
  MS: 'Mississippi',
  MO: 'Missouri',
  MT: 'Montana',
  NE: 'Nebraska',
  NV: 'Nevada',
  NH: 'New Hampshire',
  NJ: 'New Jersey',
  NM: 'New Mexico',
  NY: 'New York',
  NC: 'North Carolina',
  ND: 'North Dakota',
  OH: 'Ohio',
  OK: 'Oklahoma',
  OR: 'Oregon',
  PA: 'Pennsylvania',
  PR: 'Puerto Rico',
  RI: 'Rhode Island',
  SC: 'South Carolina',
  SD: 'South Dakota',
  TN: 'Tennessee',
  TX: 'Texas',
  UT: 'Utah',
  VT: 'Vermont',
  VA: 'Virginia',
  WA: 'Washington',
  WV: 'West Virginia',
  WI: 'Wisconsin',
  WY: 'Wyoming',
}

export function isValidAddress(address: $Shape<Address>): boolean {
  if (address && address.line1 && address.city && address.state && address.postalCode) {
    if (address.state.length === 2 && address.postalCode.length > 4) {
      return true
    }
  }
  return false
}

export function formatAddress(address: $Shape<Address>, fuzzy: boolean = false): string {
  const region = [address.state, address.postalCode].filter(x => x).join(' ')
  const street = fuzzy ? [] : [address.line1, address.line2]
  return [...street, address.city, region].filter(x => x).join(', ')
}

export function geocodeAddress(address: $Shape<Address>): Promise<$Shape<Address>> {
  const location = [address.line1, address.city, address.state, address.postalCode]
    .filter(val => val)
    .join(', ')

  return geocode(location).then(({ lat, lng }) => {
    return {
      ...address,
      latitude: lat,
      longitude: lng,
    }
  })
}

export function getShortPostalCode(postalCode: string): string {
  return postalCode.split('-')[0]
}
